import React, { useEffect } from "react";
import styles from "./FormSuccessPage.module.scss";
import { useNavigate } from "react-router-dom"
const FormSuccessPage = () => {
    useEffect(() => {
        document.title = "Briding 365 | Form submitted successfully";
    }, []);
    const navigate = useNavigate()
    return (
        <div className={styles.formSuccessPage}>
            <p className={styles.head}>Thank you for your application !</p>
            <p className={styles.subHead}>We received your application and will reveiew it in consideration for lenders that are suitable. We will contact you if we need any further details</p>
            <p className={styles.link} onClick={() => navigate("/", { replace: true })} to="/">Back to Home</p>
        </div>
    );
};

export default FormSuccessPage;
